import m from "./highrise1244.mjs";
import t from "./highrise1245.mjs";
import s from "./highrise1246.mjs";
import f from "./highrise1247.mjs";
import i from "./highrise1248.mjs";
import p from "./highrise1249.mjs";
import J from "./highrise1250.mjs";
import e from "./highrise1251.mjs";
import a from "./highrise1252.mjs";
import c from "./highrise1253.mjs";
import d from "./highrise1254.mjs";
import h from "./highrise1255.mjs";
import l from "./highrise1256.mjs";
import u from "./highrise1257.mjs";
import R from "./highrise1258.mjs";
const r = {
  hr: e,
  da: m,
  nl: d,
  "en-US": s,
  fi: i,
  "fr-CA": p,
  "fr-FR": J,
  de: t,
  hu: a,
  it: c,
  no: h,
  "pt-BR": l,
  "pt-PT": u,
  es: f,
  sv: R
}, M = (n) => {
  const o = r[n];
  return o || r["en-US"];
};
export {
  M as createGHLUIStrings
};
